import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const TrainIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <rect x="5" y="3" width="14" height="13" rx="4" />
    <line x1="5" y1="10.5" x2="19" y2="10.5" />
    <line x1="9" y1="6.5" x2="9" y2="10.5" />
    <line x1="15" y1="6.5" x2="15" y2="10.5" />
    <line x1="8" y1="20.5" x2="6" y2="20.5" />
    <line x1="18" y1="20.5" x2="16" y2="20.5" />
    <line x1="8.5" y1="16" x2="6.5" y2="20.5" />
    <line x1="15.5" y1="16" x2="17.5" y2="20.5" />
  </svg>
);

export default TrainIcon;
